import React from "react";
import Navbar from "../components/portfolio/Navbar";
import Hero from "../components/portfolio/Hero";
import About from "../components/portfolio/About";
import Brands from "../components/portfolio/Brands";
import Services from "../components/portfolio/Services";
import Work from "../components/portfolio/Work";
import Process from "../components/portfolio/Process";
import Testimonials from "../components/portfolio/Testimonials";
import Contact from "../components/portfolio/Contact";
import Footer from "../components/portfolio/Footer";

export default function Home() {
  return (
    <main className="relative min-h-screen bg-[var(--bg)] text-[var(--text)]">
      <Navbar />
      <Hero />
      <About />
      <Brands />
      <Services />
      <Work />
      <Process />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
